/* eslint-disable @angular-eslint/component-selector */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthRequestPacCommercialState } from '@shared/model';
import { ToastMessageOptions } from 'primeng/api';

@Component({
    selector: 'gold-card-tab',
    templateUrl: './gold-card-tab.component.html',
    styleUrls: ['./gold-card-tab.component.scss'],
    standalone: false
})
export class GoldCardTabComponent {
  @Input() authRequestState: AuthRequestPacCommercialState;
  @Input() tenantName: string;
  @Input() isInternal: boolean;
  @Input() isGoldCardVisible = false;

  @Output() backStep = new EventEmitter<void>();
  @Output() cancelProcess = new EventEmitter<void>();
  @Output() submitStep = new EventEmitter<void>();
  @Output() update = new EventEmitter<any | void>();

  goldCardMessage: ToastMessageOptions = {
    summary: 'Gold Card Authorization:',
    detail: 'You are requesting a preauthorization exempt service. There is no need to proceed further. If the request is submitted, it will be auto adjudicated.'
  };

  onClickBack(): void {
    this.backStep.emit();
  }

  onCancel(): void {
    this.cancelProcess.emit();
  }

  onSubmit(): void {
    this.update.emit(null);
    this.submitStep.emit();
  }
}
